// extracted by mini-css-extract-plugin
export default {"wrapper":"TransitionComponent_wrapper__IBSyk"};